/** Tela pedida antes de cair no login (`/login?next=...`), só caminhos internos. */
export function proximaTela() {
  const next = new URLSearchParams(window.location.search).get("next") || "";
  if (!next.startsWith("/") || next.startsWith("//") || next.startsWith("/login")) return null;
  return next;
}
